import { GroupWork } from '@mui/icons-material'
import PhysicalExperienceEdit from './PhysicalExperienceEdit'
import PhysicalExperienceCreate from './PhysicalExperienceCreate'
import PhysicalExperienceList from './PhysicalExperienceList'

const physicalExperienceIndex = {
  icon: GroupWork,
  list: PhysicalExperienceList,
  edit: PhysicalExperienceEdit,
  create: PhysicalExperienceCreate,
}

export default physicalExperienceIndex
